import { useState, useEffect, useRef } from 'react'
import type { UploadProps } from 'antd';
import { message, Upload } from 'antd'
import { addFileRow } from '../../api/common'
import { absolute } from '@antv/x6/lib/registry/port-layout/absolute'
import { UploadOutlined, PictureOutlined } from '@ant-design/icons';
interface Props {
    onRefresh?: (id: any, file?: any) => void
    type?: any
    uploadText?: any
    accept?: any
}

interface State {

}
const { Dragger } = Upload;

const InitUpload = (props: Props) => {
    const [uploadText, setUploadText] = useState<string>('');
    const [accept, setAccept] = useState<string>('image/*');

    useEffect(() => {
        if (!props.uploadText) {
            setUploadText("图片")
        } else {
            setUploadText("文档")
        }
    }, [props.uploadText])
    useEffect(() => {
        if (!props.accept) {
            setAccept('image/*')
        } else {
            setAccept(props.accept)
        }
    }, [props.accept])
    const onUploadOther = async (e: any): Promise<any> => {
        let file: any = e.target.files[0]
        if (!file) return;
        props.onRefresh!(file)
    }
    /**
    /**
     * @name 上传图片
     */
    const onUpload = async (e: any): Promise<any> => {
        console.log(e)

        let file: any = e.target.files[0]
        if (!file) return;
        let format: string = file.type.split('/')[1]
        if (file.size > 1024 * 1024 * 5) {
            message.info('图片大小不可超过5M')
            return
        }
        console.log('format', format)
        if (format === 'jpg' || format === 'jpeg' || format === 'png' || format.includes('gif') || format.includes('webp') || format.includes('svg')) {
            let params = new FormData()
            params.append('raw', file)
            try {
                let response: any = await addFileRow(params, file.name, '')
                if (response.ok) {
                    props.onRefresh!(response.data.id, file)
                    let file1: any = document.getElementById('file');
                    file1.value = '';
                }
            } catch (err) { }
        } else {
            message.info('支持jpg、png格式的图片')
        }
    }

    return (
        <> {props.type === 'tuozhai' ? <>
            <div className="init ant-upload ant-upload-select ant-upload-select-picture-card">
                <span className="ant-upload" role="button">
                    <input type="file" accept={accept} style={{
                        opacity: 0, zIndex: 2, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                    }} onChange={(e: any) => {
                        if (uploadText == '图片') {
                            onUpload(e)
                        } else {
                            onUploadOther(e)
                        }
                    }} />
                    <div>
                        {uploadText == '图片' && <PictureOutlined className='icon_hover' style={{ fontSize: '40px' }} />}
                        <div style={{ marginTop: '8px' }}>将{uploadText}拖拽到此处，或<span style={{ color: '#567AEF' }}>点击添加</span></div>
                    </div>
                </span>
            </div>
        </> : <input id='file' accept={accept} className='pos-r' onChange={(e: any) => {
            if (uploadText == '图片') {
                onUpload(e)
            } else {
                onUploadOther(e)
            }
        }} type="file" style={{
            opacity: 0, zIndex: 2, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
        }} placeholder='' />}
        </>
    )
}

export default InitUpload